module.exports = __webpack_public_path__ + "static/img/s151.af584849.png";